import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getNotableTitles } from '../../../services/studies';
import styles from './notableTitles.module.css';

export default function NotableTitles() {
  const [notableStudies, setNotableStudies] = useState([]);

  useEffect(() => {
    getNotableTitles()
      .then((res) => setNotableStudies(res.data))
      .catch((err) => console.error(err));
  }, []);

  const titles = notableStudies.map((study) => (
    <Link
      key={study.summary_title}
      to={`/shared?uuid=${study.uuid}&docType=${study.doc_type}`}
      target="_blank"
    >
      <p className={styles.notableTitle}>{study.summary_title}</p>
    </Link>
  ));

  return (
    <section
      id="notable-titles"
      role="complementary"
      aria-label="notable studies"
      className={styles.notableContainer}
    >
      <h4>Notable Studies</h4>
      <div className={styles.titlesContainer}>
        {/* <Link to='/studies?notable=true' className="textLink" style={{ backgroundColor : 'white' }}>
          See More Info
        </Link> */}
        {titles}
      </div>
    </section>
  );
}
